import {
  CommonColumnsType,
  DownloadConfigInfoType,
  DownloadParamsType,
} from '@op/pages/download/types';
import type { IDouyinHashtagItem } from '@opm/pages/Hashtag/tabs/DouyinTab/constants';

// ─────────────────────────────────────────────────────────
// Download Config
// ─────────────────────────────────────────────────────────
//
// 调用方传入：
//   data: IDouyinHashtagItem[]  —— hook 全量 records
//
// Excel 布局：
//   Date | Rank | Hashtag | Heat
//
export const MarketingHashtagDouyinDownload: DownloadConfigInfoType = {
  columns: (): CommonColumnsType => [
    { key: 'date', header: 'Date' },
    { key: 'rank', header: 'Rank' },
    { key: 'hashtag', header: 'Hashtag' },
    { key: 'hashtag_en', header: 'Hashtag En' },
    { key: 'heat', header: 'Heat' },
  ],

  dealWithDataFunc: ({ data }: DownloadParamsType) => {
    const records: IDouyinHashtagItem[] = data || [];
    return [...records]
      .sort((a, b) => {
        if (a.date !== b.date) return a.date < b.date ? 1 : -1;
        return a.rank - b.rank;
      })
      .map((item) => ({
        date: item.date,
        rank: item.rank,
        hashtag: item.hashtag,
        hashtag_en: item.hashtag_en,
        heat: item.heat,
      }));
  },
};
